// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-button[data-v-6643b714]{padding-right:10px}.date-picker[data-v-6643b714]{margin-bottom:20px}.footer-total[data-v-6643b714]{margin:16px}.footer-text[data-v-6643b714]{padding:16px;background:var(--pult-surface)}.select-range[data-v-6643b714]{width:100%}", ""]);
// Exports
module.exports = exports;
